import TableContainer from "components/Common/DataTableContainer"
import React, { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import {
  cancelStallBooking,
  fetchStallList,
  getPaymentStatistics,
} from "../../../redux/actions/pvs"
import { Button } from "reactstrap"
import ConfirmPopup from "components/ConfirmPopup"
import ErrorPopup from "components/ErrorPopup"
import { GET_PAYMENT_STATISTICS_RESET } from "../../../redux/types/pvs"
import { toast } from "react-toastify"
import PageLoader from "components/Common/PageLoader"

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

export const PaymentStatistics = () => {
  document.title = "Payment Statistics | PULA"

  const query = useQuery()
  const bazaarId = query.get("id")

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [isOpen, setisOpen] = useState(false)
  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isErrorMessage, setIsErrorMessage] = useState("")
  const [selectedStall, setSelectedStall] = useState(null)
  const [selectedBazaar, setselectedBazaar] = useState(null)

  const token = useSelector(state => state.auth.token)
  const stalls = useSelector(state => state.pvs.stallList)
  const paymentStatistics = useSelector(state => state.pvs.paymentStatistics)
  const getPaymentStatisticsScreen = useSelector(
    state => state.screens.pvs.getPaymentStatistics
  )

  useEffect(() => {
    dispatch(getPaymentStatistics({}))
  }, [])

  //   useEffect(() => {
  //     if (getPaymentStatisticsScreen.success) {
  //       toast.success(getPaymentStatisticsScreen.message)
  //       dispatch({ type: GET_PAYMENT_STATISTICS_RESET })
  //     }
  //     if (getPaymentStatisticsScreen.error) {
  //       // toast.error(getPaymentStatisticsScreen.error)
  //       setIsErrorMessage(getPaymentStatisticsScreen.error)
  //       setIsErrorOpen(true)
  //       dispatch({ type: GET_PAYMENT_STATISTICS_RESET })
  //     }
  //   }, [getPaymentStatisticsScreen])

  const columns = useMemo(
    () => [
      {
        header: "Bazaar Name",
        accessorKey: "bazaar_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Cash",
        accessorKey: "cash",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const value = info.getValue()
          return (
            <span>{value ? `₹ ${value.toLocaleString("en-IN")}` : " - "}</span>
          )
        },
      },
      {
        header: "Bank Transfer",
        accessorKey: "bank_transfer",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const value = info.getValue()
          return (
            <span>{value ? `₹ ${value.toLocaleString("en-IN")}` : " - "}</span>
          )
        },
      },
      {
        header: "UPI",
        accessorKey: "upi",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const value = info.getValue()
          return (
            <span>{value ? `₹ ${value.toLocaleString("en-IN")}` : " - "}</span>
          )
        },
      },
      {
        header: "Cheque",
        accessorKey: "cheque",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const value = info.getValue()
          return (
            <span>{value ? `₹ ${value.toLocaleString("en-IN")}` : " - "}</span>
          )
        },
      },
      {
        header: "Total",
        accessorKey: "total_payment_amount",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const value = info.getValue()
          return (
            <span>{value ? `₹ ${value.toLocaleString("en-IN")}` : " - "}</span>
          )
        },
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const row = info.row.original
          return (
            <div className="d-flex align-items-center gap-2">
              <button
                className="btn btn-sm btn-info"
                onClick={() => navigate(`/booking-report?id=${row.enc_combine_group_id}`)}
              >
                Bookings
              </button>
               <button
                className="btn btn-sm btn-warning"
                onClick={() => navigate(`/balance-report?id=${row.enc_combine_group_id}`)}
              >
                Balance
              </button>
            </div>
          )
        },
      },
    ],
    [navigate]
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-end mt-3 mb-3">
          <div className="flex-grow-1">
            <h4 className="h4 mb-0 nom-title">Payment Statistics</h4>
          </div>
        </div>
        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={paymentStatistics || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          isAddButton={false}
          buttonClass="btn btn-primary"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4"
        />
      </div>
      {/* <PageLoader open={getPaymentStatisticsScreen.loading} /> */}
    </div>
  )
}

export default PaymentStatistics
